import {bgmiBase} from './bgmi/bgmiBase';
import {chatCoffeeBase} from './chatCoffee/chatCoffeeBase';
import {chatiwiBase} from './chatiwi/chatiwiBase';
import {chatiwinBase} from './chatiwin/chatiwinBase';
import {hardBase} from './hard/hardBase';
import {sextingAnonymousBase} from './sextingAnonymous/sextingAnonymousBase';
import {sextyNineBase} from './sextyNine/sextyNineBase';
import type {BrandBase} from './BrandBase';
import type {BrandId} from './BrandId';

export const brandsBase: Record<BrandId, BrandBase> = {
  bgmi: bgmiBase,
  chatiwin: chatiwinBase,
  chatiwi: chatiwiBase,
  chatCoffee: chatCoffeeBase,
  hard: hardBase,
  sextyNine: sextyNineBase,
  sextingAnonymous: sextingAnonymousBase,
};
